import type { AuthenticationResult } from '@azure/msal-browser';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { AUTH_CALLBACK_PATHS, getDefaultApiScope } from '@endurance/platform-contracts';
import config from '../config';
import { requiresInteractiveAuthentication } from './authErrors';

const msalConfig = {
  auth: {
    ...config.auth,
    //Ensures that the '.../authorize' route is used as the redirect URI regardless of environment
    redirectUri: `${window.location.origin}${AUTH_CALLBACK_PATHS.LEGACY}`,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const authClient = new PublicClientApplication(msalConfig);

// The first account signed in will be used for authentication
if (!authClient.getActiveAccount() && authClient.getAllAccounts().length > 0) {
  authClient.setActiveAccount(authClient.getAllAccounts()[0]);
}
authClient.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    if (payload.account) {
      authClient.setActiveAccount(payload.account);
    }
  }
});

export const acquireTokenAsync = async (forceRefresh = false): Promise<any> => {
  const account = authClient.getActiveAccount() ?? authClient.getAllAccounts()[0];

  if (account && !authClient.getActiveAccount()) {
    authClient.setActiveAccount(account);
  }

  try {
    return await authClient.acquireTokenSilent({
      account: account ?? undefined,
      scopes: [getDefaultApiScope(config.auth.clientId)],
      forceRefresh,
    });
  } catch (error) {
    if (!requiresInteractiveAuthentication(error)) {
      throw error;
    }

    return await authClient.acquireTokenRedirect({
      account: account ?? undefined,
      scopes: [getDefaultApiScope(config.auth.clientId)],
    });
  }
};

export const logout = () => {
  authClient.logoutRedirect();
};
